import { Form, Table } from "react-bootstrap";
import { useState } from "react";
import AddCategory from "./AddCategory";
import UpdateCategory from "./UpdateCategory";
import Moment from "react-moment";
import { useEffect } from "react";
import Swal from "sweetalert2";
import UseToggle from "../../../../../Hooks/UseToggle";
import { storeCategoryServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCategoryServices";
import ToolBar from "../../../../Componant/ToolBar";

const CategoryManagement = ({getActiveStoreCategoryList}) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [storeCategories, setStoreCategories] = useState([]);
  const [storeCategoryData, setStoreCategoryData] = useState("");
  const [storeCategoryCount, setStoreCategoryCount] = useState(0);
  const [storeCategoryIds, setStoreCategoryIds] = useState([]);

  const toggleSingle = (id) => {
    setStoreCategoryIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (storeCategoryIds.length === storeCategories.length) {
      setStoreCategoryIds([]);
    } else {
      setStoreCategoryIds(storeCategories.map((c) => c.id));
    }
  };

  const isAllChecked =
    storeCategories.length > 0 && storeCategoryIds.length === storeCategories.length;
  const isChecked = (id) => storeCategoryIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(storeCategoryCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, storeCategoryCount);

  const getStoreCategoryList = async () => {
    setLoader(true);
    let data = await storeCategoryServices.getStoreCategoryList(
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setStoreCategories(data?.data || []);
    setStoreCategoryCount(data?.count || 0);
    setLoader(false);
  };

  const updatedStoreCategory = async (categoryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status} this Store Category?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.categoryId = categoryId;
        userData.status = status;
        let data = await storeCategoryServices.updatedStoreCategory(userData);
        if (data?.statusCode === 200) {
          getActiveStoreCategoryList();
          getStoreCategoryList();
        }
      }
    });
  };

  const deleteStoreCategory = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Store Category?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.categoryIds = storeCategoryIds;
        let data = await storeCategoryServices.deleteStoreCategory(userData);
        if (data?.statusCode === 200) {
          getActiveStoreCategoryList();
          getStoreCategoryList();
        }
      }
    });
  };

  useEffect(() => {
    let storeCategoryData = storeCategories?.find(
      (item) => item.categoryId === storeCategoryIds?.[0],
    );
    setStoreCategoryData(storeCategoryData || "");
  }, [storeCategoryIds]);

  useEffect(() => {
    getStoreCategoryList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={storeCategoryIds}
        setCheckedIds={setStoreCategoryIds}
        start={start}
        end={end}
        totalItems={storeCategoryCount}
        page={pageNumber}
        setPage={setPageNumber}
        setPageSize={setItemsPerPage}
        pageSize={itemsPerPage}
        totalPages={totalPages}
        deleteData={deleteStoreCategory}
        addField
        editField
      />
      <div className={`contacts-layout`}>
        <div
          className={`table-section overflow-auto bg-white `}
          style={{ height: "calc(100vh - 153px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Category</div>
                  </div>
                </th>
                <th>Total Post</th>
                <th>Status</th>
                <th>Created Date | Time</th>
                <th>Updated Date | Time</th>
              </tr>
            </thead>
            <tbody>
              {storeCategories?.map((item) => (
                <tr key={item.categoryId}>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(item.categoryId)}
                          onChange={() => toggleSingle(item.categoryId)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>
                        <div className="fw-medium">{item.name}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="fw-medium">{item.totalPost || 0}</span>
                  </td>
                  <td>
                    <Form.Check
                      type="switch"
                      onChange={() =>
                        updatedStoreCategory(
                          item?.categoryId,
                          item.status === "active" ? "inactive" : "active",
                        )
                      }
                      checked={item.status === "active"}
                    />
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </span>
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.updatedAt}
                      </Moment>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <AddCategory
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Category`}
        getStoreCategoryList={getStoreCategoryList}
        getActiveStoreCategoryList={getActiveStoreCategoryList}
      />
      <UpdateCategory
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Category`}
        storeCategoryData={storeCategoryData}
        setStoreCategoryData={setStoreCategoryData}
        setStoreCategoryIds={setStoreCategoryIds}
        getStoreCategoryList={getStoreCategoryList}
        getActiveStoreCategoryList={getActiveStoreCategoryList}
      />
    </>
  );
};

export default CategoryManagement;
